<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <BaseInputValidation
              id="login"
              name="Login"
              v-model="password.email"
              :loading="loading"
              disabled
            ></BaseInputValidation>
          </v-col>
          <v-col>
            <v-btn
              v-if="!view && !form.newSenha"
              class="btn-novo"
              @click="form.newSenha = true"
            >
              <span class="icon-plus-1"></span>
              <span>Alterar Senha</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="form.newSenha">
          <v-col>
            <BaseInputValidation
              id="password"
              type="password"
              name="Senha Atual *"
              v-model="form.password"
              rules="required"
            ></BaseInputValidation>
          </v-col>
          <v-col>
            <BaseInputValidation
              id="password_new"
              type="password"
              name="Nova Senha *"
              vid="password_new"
              v-model="form.password_new"
              rules="required|strongPassword"
            ></BaseInputValidation>
          </v-col>
          <v-col>
            <BaseInputValidation
              id="password_confirm"
              type="password"
              name="Confirmar a senha *"
              v-model="form.password_confirm"
              rules="required|confirmed:password_new"
            ></BaseInputValidation>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseInputValidation from "../../../../components/UI/BaseInputValidation.vue";

export default {
  components: {
    BaseInputValidation
  },
  props: {
    password: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: { newSenha: false }
    };
  },

  watch: {
    form: {
      handler(newVal) {
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .btn-novo {
  margin-top: 10px;
  background: #ebe6e6 !important;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 46px !important;
  padding: 0 20px 0 20px !important;
  span {
    font-weight: 300;
    font-size: 15px;
    line-height: 29px;
    text-align: center;

    color: #444444;
  }
}
</style>
